import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../index";

type WidgetWarningState = {
  visible: boolean;
};

const initialState: WidgetWarningState = {
  visible: false,
};

const slice = createSlice({
  name: "dashboard/widget/warning",
  initialState,
  reducers: {
    resetDashboardWidgetWarning: (state) => ({
      ...state,
      visible: initialState.visible,
    }),
    updateDashboardWidgetWarningVisible: (state, { payload }) => ({
      ...state,
      visible: payload,
    }),
  },
});

export const dashboardWidgetWarningSelector = (state: RootState) =>
  state.dashboard.widget.warning;
export const {
  updateDashboardWidgetWarningVisible,
  resetDashboardWidgetWarning,
} = slice.actions;

export default slice;
